







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Icon extends Vue {
  @Prop({ required: true }) public name: string

  /**
   * Get resource.
   */
  get resource() {
    return require(`@/assets/svg-icons/icon-${this.name}.svg`).default
  }
}
